import React, {
  FormEvent,
  useEffect,
  useRef,
  useState,
} from 'react'

type Props = {
  id: string
  onRead: (identifier: string) => void
  disabled?: boolean
}

const RfidIdentifierInput = ({
  id,
  onRead,
  disabled = false,
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [value, setValue] = useState('')

  useEffect(() => {
    if (!disabled) inputRef.current?.focus()
  }, [disabled])

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const identifier = value.trim()
    if (!identifier || disabled) return

    onRead(identifier)
    setValue('')
    inputRef.current?.focus()
  }

  return (
    <form className="rfid-reader-input" onSubmit={handleSubmit}>
      <label htmlFor={id}>RFID識別子</label>
      <div className="rfid-reader-input__controls">
        <input
          ref={inputRef}
          id={id}
          type="text"
          value={value}
          disabled={disabled}
          placeholder="リーダーで読み取るか、識別子を入力"
          autoComplete="off"
          onChange={(event) => setValue(event.target.value)}
        />
        <button type="submit" className="btn btn-primary" disabled={disabled || !value.trim()}>
          読み取る
        </button>
      </div>
      <p className="rfid-help-text">
        HIDキーボード方式のRFIDリーダーは、識別子の後にEnterを送信する設定で利用してください。
      </p>
    </form>
  )
}

export default RfidIdentifierInput
